.input {
  background-color: white;
  color: var(--mantine-color-gray-9);
  border-radius: var(--mantine-radius-sm);
  border: 1px solid var(--input-border-color);
  &[data-error] {
    border: 1px solid var(--mantine-color-red-6);
  }
  &::placeholder {
    color: var(--mantine-color-gray-6);
  }
}

.control {
  color: var(--mantine-color-gray-8);
  border-inline-start: 1px solid var(--mantine-color-gray-2);
}

.label {
  font-weight: 600;
  background-color: transparent;
  max-width: 100%;
}
.loader {
  background-color: var(--mantine-color-primary);
}

/* .placeholder {
  background-color: var(--mantine-color-gray-0);
  color: var(--mantine-color-gray-6);
} */

.text {
  font-size: var(--mantine-font-size-xs);
  line-height: var(--mantine-line-height-xs);
  color: var(--mantine-color-text);
}

.pill {
  background: var(--mantine-color-white);
}

.chip {
  &[data-disabled="true"] {
    background-color: var(--mantine-color-green-0);
    color: var(--mantine-color-green-7);
  }
}

.settings {
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

.panel {
  border-radius: var(--mantine-radius-lg);
  border: 1px solid var(--mantine-color-gray-2);
  padding: var(--mantine-spacing-md);
  background-color: white;
}

.multiselect {
  border-radius: var(--mantine-radius-lg);
  background-color: white;
  border: 1px solid var(--mantine-color-gray-2);
}
